import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagArchivedProps {}

const ColorTagArchived: React.FC<ColorTagArchivedProps> = props => {
  return <ColorTag className="ColorTagArchived" color="median">Archived</ColorTag>
}

export default ColorTagArchived;